<template>
	<div style="height: 100%;">
		<div class="rightDom1">
			<div class="titleTime" :style="{backgroundImage: 'url(' + timeBg1 + ')'}">
				<span class="left">{{ languageJson.Today }}</span>
				<span class="right">{{ dataList.total }}</span>
			</div>
			<div class="titleTime" :style="{backgroundImage: 'url(' + timeBg2 + ')'}">
				<span class="left">{{ languageJson.Important }}</span>
				<span class="right">{{ dataList.important }}</span>
			</div>
			<div class="titleTime" :style="{backgroundImage: 'url(' + timeBg3 + ')'}">
				<span class="left">{{ languageJson.Escalation }}</span>
				<span class="right">{{ dataList.report }}</span>
			</div>
		</div>
		<div v-if="nollData" style="width: 100%;padding: 20px 0;font-size: 0.9vw;font-weight: 600;color: white;">
			<img src="../../../../static/imgV2/none.png" style="width: 30%;" alt="">
			<div style="margin-top: 10px;">{{ languageJson.noneEvent }}</div>
		</div>
		<div v-else class="rightDom2">
			<div class="ul" v-for="(obj,$index) in dataList.eventList" :key="$index">
				<div style="text-align: left;">{{ obj.eventName }}</div>
				<div>{{ obj.robotName }}</div>
				<div style="text-align: right;">{{ obj.time }}</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		currentCount
	} from '@/api/indexV2'
	import {
		getItem
	} from '@/utils/auth'
	export default {
		data() {
			return {
				languageJson: languageJson,
				languageCheck: localStorage.getItem('language'),
				timeBg1: require('../../../../static/imgV2/green.gif'),
				timeBg2: require('../../../../static/imgV2/red.gif'),
				timeBg3: require('../../../../static/imgV2/blue.gif'),
				dataList: {
					important: '',
					report: '',
					total: '',
					eventList: []
				},
				nollData: false
			}
		},
		props: {
			changeTime: Boolean
		},
		mounted() {
			this.currentCount()
		},
		methods: {
			currentCount() {
				let that = this
				currentCount(getItem('tenantInfoId')).then(res => {
					if(res && res.data) {
						that.dataList = res.data
						if (res.data.eventList && res.data.eventList.length > 0) {
							that.nollData = false
						} else {
							that.nollData = true
						}
					}
				})
			}
		},
		watch: {
			changeTime: {
				deep: true,
				immediate: false,
				handler(newData, oldData) {
					this.currentCount()
				}
			}
		}
	}
</script>

<style scoped lang="less">
	.rightDom1 {
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 90%;
		height: 20%;
		margin: 10px auto;

		.titleTime {
			background-size: 100% 100%;
			padding: 10px 0;
			display: flex;
			justify-content: space-between;
			align-items: center;
			width: 30%;
			color: white;
			font-size: 0.8vw;
			font-weight: 600;

			.left {
				margin-left: 10px;
			}
			.right {
				margin-right: 10px;
			}
		}
	}
	.rightDom2 {
		width: 90%;
		margin: 0 auto;
		height: 75%;
		overflow-y: auto;

		.ul {
			width: 100%;
			display: flex;
			justify-content: space-between;
			align-items: center;
			color: white;
			font-size: 0.8vw;
			padding: 0.4vw 0;

			div {
				width: 30%;
			}
		}

		.ul:nth-child(2n+1) {
			background-color: #0c234c;
		}
	}
</style>



// WEBPACK FOOTER //
// src/page/customIndex/components/leftBottomLeft.vue